import React from "react";
import { useHistory } from "react-router";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import MenuButton from "./MenuButton";
import { useTranslation } from "react-i18next";

function BackButton() {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <MenuButton
      id="navBtnBack"
      title={t("common.buttons.back")}
      icon={<ArrowBackOutlinedIcon />}
      paths={[]}
      func={() => history.goBack()}
    />
  );
}

export default BackButton;
